import { Component, Input } from "@angular/core"
import { ModalRef } from "../../../shared-components/modal/modal-ref"

@Component({
    selector: "app-agreement-modal",
    templateUrl: "./agreement-modal.component.html",
    styleUrls: ["./agreement-modal.component.scss"],
})
export class AgreementModalComponent {
    @Input() public downloadUrl: string

    constructor(public activeModal: ModalRef) {}
}
